import { useMemo } from 'react';

import { StatusLevel } from '@scaleaq/sitecontrol-lib';
import { useTranslation } from 'react-i18next';

export const useStatusLevelLabels = (): Record<StatusLevel, string> => {
  const { t: tDeviceConfig } = useTranslation('deviceConfig');
  return useMemo(
    () =>
      ({
        [StatusLevel.Healthy]: tDeviceConfig('statusLevelLabels.healthy'),
        [StatusLevel.Error]: tDeviceConfig('statusLevelLabels.error'),
        [StatusLevel.Warning]: tDeviceConfig('statusLevelLabels.warning'),
        [StatusLevel.Critical]: tDeviceConfig('statusLevelLabels.critical'),
      }) satisfies Record<StatusLevel, string>,
    [tDeviceConfig]
  );
};
